import React, { FunctionComponent } from "react"

interface BulbIconProps {}

const BulbIcon: FunctionComponent<BulbIconProps> = () => {
  return (
    <svg
      width="52"
      height="62"
      viewBox="0 0 52 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_956_677)">
        <path
          d="M21.8335 37H30.1668"
          stroke="#FFDA66"
          stroke-width="3.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.6665 42H29.3332"
          stroke="#FFDA66"
          stroke-width="3.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.15 32C31.45 30.3667 32.2333 29.1 33.5 27.8333C34.3048 27.0925 34.9436 26.1897 35.3745 25.1843C35.8054 24.1789 36.0186 23.0937 36 22C36 19.3478 34.9464 16.8043 33.0711 14.9289C31.1957 13.0536 28.6522 12 26 12C23.3478 12 20.8043 13.0536 18.9289 14.9289C17.0536 16.8043 16 19.3478 16 22C16 23.6667 16.3833 25.7167 18.5 27.8333C19.7068 28.9368 20.53 30.3964 20.85 32"
          fill="#FFC200"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.7506 13.7511C19.9385 11.5631 22.906 10.334 26.0002 10.334C29.0944 10.334 32.0618 11.5631 34.2497 13.7511C36.4344 15.9357 37.6631 18.8975 37.6668 21.9867C37.6873 23.3107 37.4282 24.6243 36.9066 25.8415C36.3879 27.0517 35.6213 28.1395 34.6563 29.0349C33.574 30.1227 33.0112 31.0939 32.7894 32.3017C32.6441 33.0928 31.9545 33.6673 31.1502 33.6673H20.8502C20.0554 33.6673 19.3712 33.1062 19.2157 32.3268C18.9651 31.0711 18.3205 29.9281 17.3755 29.064C17.3572 29.0472 17.3392 29.0301 17.3217 29.0125C14.8245 26.5154 14.3335 24.0031 14.3335 22.0007C14.3335 18.9065 15.5627 15.939 17.7506 13.7511ZM26.0002 13.6673C23.79 13.6673 21.6704 14.5453 20.1076 16.1081C18.5448 17.6709 17.6668 19.7905 17.6668 22.0007C17.6668 23.3254 17.9399 24.9046 19.6547 26.6314C20.7641 27.6547 21.6043 28.9265 22.1115 30.334H29.8758C30.3794 28.9256 31.222 27.7551 32.3216 26.6555C32.3379 26.6392 32.3545 26.6233 32.3714 26.6078C33.0031 26.0263 33.5045 25.3176 33.8427 24.5284C34.181 23.7392 34.3483 22.8874 34.3337 22.0289L34.3335 22.0007C34.3335 19.7905 33.4555 17.6709 31.8927 16.1081C30.3299 14.5453 28.2103 13.6673 26.0002 13.6673Z"
          fill="#FFC200"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_956_677"
          x="-8"
          y="-3"
          width="68"
          height="68"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_956_677"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0 0 0 0 0.32 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_956_677"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_956_677"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default BulbIcon
